import React from "react";
import { TabView, TabPanel } from "primereact/tabview";

export default function Tabview({
	className,
	disabled = false,
	items = [
		{
			header: "Header 1",
			body: (
				<p className="m-0">
					Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
					eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
					minim veniam, quis nostrud exercitation ullamco laboris nisi ut
					aliquip ex ea commodo consequat. Duis aute irure dolor in
					reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
					pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
					culpa qui officia deserunt mollit anim id est laborum.
				</p>
			),
		},
		{
			header: "Header 2",
			body: (
				<p className="m-0">
					At vero eos et accusamus et iusto odio dignissimos ducimus qui
					blanditiis praesentium voluptatum deleniti atque corrupti quos dolores
					et quas molestias excepturi sint occaecati cupiditate non provident,
					similique sunt in culpa qui officia deserunt mollitia animi, id est
					laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita
					distinctio. Nam libero tempore, cum soluta nobis est eligendi optio
					cumque nihil impedit quo minus.
				</p>
			),
		},
	],
	onTabChanged,
	activeIndex,
	editingDone,
}) {
	return (
		<div className={`card w-full ${className}`}>
			<TabView
				activeIndex={activeIndex}
				onTabChange={(e) => onTabChanged(e.index)}
			>
				{items.map((data, key) => {
					return (
						<TabPanel
							header={data.header}
							key={key}
							disabled={data.disabled}
							headerStyle={{ fontSize: 20 }}
						>
							{data.body}
						</TabPanel>
					);
				})}
			</TabView>
		</div>
	);
}
